import axios from '@/axios'

class AddressDataService {
  async getAllServicePackages(page: number): Promise<any> {
    return axios.get(`/address/getAllAddresses?page=${page}`)
  }
  async getAddressById(id: any): Promise<any> {
    return axios.get(`/address/${id}/get`)
  }
  async add(data: any): Promise<any> {
    return axios.post('/address/add', data)
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/address/${id}/update`, data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/address/${id}/delete`)
  }
  async getAllAddresses(): Promise<any> {
    return axios.get('/address/getAllAddresses')
  }
}
export default new AddressDataService()